
/**
 * PAGINATION - Gère la navigation entre les pages d'ordres
 * @param {Object} props
 * @param {number} props.currentPage - Page actuelle
 * @param {number} props.totalPages - Nombre total de pages
 * @param {Function} props.onPageChange - Callback changement de page
 */
const OrderPagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <nav className='mt-5'>
      <ul className="pagination justify-content-center">
        {/* Bouton précédent */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button 
            className="page-link" 
            onClick={() => onPageChange(currentPage - 1)} 
            disabled={currentPage === 1}
          >
            <i className="fa-solid fa-angle-left"></i>
          </button>
        </li>
        
        {/* Numéros de page */}
        {[...Array(totalPages)].map((_, index) => (
          <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => onPageChange(index + 1)}
            >
              {index + 1}
            </button>
          </li>
        ))}
        
        {/* Bouton suivant */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button 
            className="page-link" 
            onClick={() => onPageChange(currentPage + 1)} 
            disabled={currentPage === totalPages}
          >
            <i className="fa-solid fa-angle-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default OrderPagination;